<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm sending</v-card-title>
    <v-card-text>Are you sure you want to email invoice {{hefc.hefc_nr}} ?  <B>(Sending may take a few seconds)</B></v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="clicked" class="warning mx-2" small @click="sentHefcByEmail">Yes</v-btn>
      <v-btn :disabled="clicked" color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      clicked: false,
      hefc_encrid: null,
      hefc: {}
    }
  },
  methods: {
    open(hefc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/getHefcTmp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHefcTmp"
          },
          getHefcTmp: {
            hefc_encrid: hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hefc = res.data.getHefcTmp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sentHefcByEmail() { 
      this.clicked = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/sentHefcByEmail.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "sentHefcByEmail"
          },
          sentHefcByEmail: {
            hefc_encrid: this.hefc.hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.sentHefcByEmail.text,
              color: res.data.sentHefcByEmail.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

